<div class="text-center" *ngIf="show">
    <div class="spinner-border text-primary" role="status"></div>
</div>
